import { LoadingOutlined } from '@ant-design/icons'
import { createStyles } from 'antd-style'

import { pick } from '@eastcoal/common/utils/object'

import { ImageCardImg } from '../Img'
import { useImageCardStore } from '../Store/hooks/useStore'

const useStyles = createStyles(({ token }) => ({
  imageLoading: {
    position: 'relative',
    maxWidth: '100%'
  },
  imgEl: {
    maxWidth: '100%',
    opacity: 0.6
  },
  loadingProgress: {
    position: 'absolute',
    bottom: 5,
    right: 5,
    padding: token.paddingXXS,
    borderRadius: token.borderRadiusXS,
    lineHeight: 1,
    fontSize: token.fontSize,
    color: token.colorWhite,
    backgroundColor: '#000'
  }
}))

export const ImageLoading = () => {
  const { ossUrl, filename } = useImageCardStore(state =>
    pick(state, ['ossUrl', 'filename'])
  )

  const { styles } = useStyles()

  return (
    <div className={styles.imageLoading}>
      <ImageCardImg alt={filename} className={styles.imgEl} src={ossUrl} />
      <div className={styles.loadingProgress}>
        <LoadingOutlined />
        <span>上传中</span>
      </div>
    </div>
  )
}
